module.exports = __webpack_public_path__ + "static/img/f8e142d2917281a9593cc227a3c83dde.5667dfb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/f8e142d2917281a9593cc227a3c83dde.jpeg
// module id = WBaU
// module chunks = 0